import { BoxProps, TextProps } from '@jfs/ui-new'
import { Colors } from '../../utils'

const defaultStyles: any = {
  greenStatus: {
    backgroundColor: Colors.GREEN_BG_C,
    color: Colors.GREEN_C,
    alignItems: 'center',
    flex: 1,
    borderRadius: 2,
    maxWidth: 80,
    underlayColor: 'TRANSPARENT',
  } as BoxProps,
  redStatus: {
    backgroundColor: Colors.RED_BG_C,
    color: Colors.RED_C,
    alignItems: 'center',
    flex: 1,
    borderRadius: 2,
    maxWidth: 80,
    underlayColor: 'TRANSPARENT',
  } as BoxProps,
  orangeStatus: {
    backgroundColor: Colors.ORANGE_BG_C,
    color: Colors.ORANGE_C,
    alignItems: 'center',
    flex: 1,
    borderRadius: 2,
    maxWidth: 80,
    underlayColor: 'TRANSPARENT',
  } as BoxProps,
  orangeStatusBigger: {
    backgroundColor: Colors.ORANGE_BG_C,
    color: Colors.ORANGE_C,
    alignItems: 'center',
    flex: 1,
    borderRadius: 2,
    maxWidth: 160,
    underlayColor: 'TRANSPARENT',
  } as BoxProps,
  greyStatus: {
    backgroundColor: Colors.GREY_EB,
    color: Colors.GREY_C,
    alignItems: 'center',
    flex: 1,
    borderRadius: 2,
    maxWidth: 80,
    underlayColor: 'TRANSPARENT',
  } as BoxProps,
  blueStatus: {
    backgroundColor: Colors.BLUE_BG_C,
    color: Colors.BLUE_C,
    alignItems: 'center',
    flex: 1,
    borderRadius: 2,
    maxWidth: 80,
    underlayColor: 'TRANSPARENT',
  } as BoxProps,
}

export const freezedColumnStyle = (width: number) => {
  return {
    position: 'sticky',
    zIndex: 10,
    left: 0,
    margin: 0,
    padding: 0,
    minWidth: width,
    height: '100%',
    backgroundColor: 'WHITE',
  } as BoxProps
}

export const styles: any = {
  success: {
    ...defaultStyles.greenStatus,
  } as BoxProps,
  failed: {
    ...defaultStyles.redStatus,
  } as BoxProps,
  approval_in_progress: {
    ...defaultStyles.orangeStatusBigger,
  } as BoxProps,
  retry_in_progress: {
    ...defaultStyles.orangeStatusBigger,
  } as BoxProps,
  closure_in_progress: {
    ...defaultStyles.orangeStatusBigger,
  } as BoxProps,
  accepted: {
    ...defaultStyles.blueStatus,
  } as BoxProps,
  paused: {
    ...defaultStyles.redStatus,
  } as BoxProps,
  active: {
    ...defaultStyles.greenStatus,
  } as BoxProps,
  scheduled: {
    ...defaultStyles.orangeStatus,
  } as BoxProps,
  completed: {
    ...defaultStyles.greyStatus,
  } as BoxProps,
  complete: {
    ...defaultStyles.greenStatus,
  } as BoxProps,
  'in progress': {
    ...defaultStyles.orangeStatus,
  } as BoxProps,
  pendingForApproval: {
    ...defaultStyles.orangeStatusBigger,
  } as BoxProps,
  pending: {
    ...defaultStyles.orangeStatus,
  } as BoxProps,
  paid: {
    ...defaultStyles.greenStatus,
  } as BoxProps,
  expired: {
    ...defaultStyles.redStatus,
  } as BoxProps,
  issued: {
    ...defaultStyles.blueStatus,
  } as BoxProps,
  cancelled: {
    ...defaultStyles.orangeStatus,
  } as BoxProps,
  inprocess: {
    ...defaultStyles.blueStatus,
  } as BoxProps,
  deleted: {
    ...defaultStyles.redStatus,
  } as BoxProps,
  blocked: {
    ...defaultStyles.orangeStatus,
  } as BoxProps,
  inactive: {
    ...defaultStyles.greyStatus,
  } as BoxProps,
  error: {
    ...defaultStyles.redStatus,
  } as BoxProps,
  defaultCell: {
    justifyContent: 'center',
    underlayColor: 'TRANSPARENT',
    paddingVertical: 16,
  } as BoxProps,
  canceled: {
    ...defaultStyles.redStatus,
  } as BoxProps,
  initiated: {
    ...defaultStyles.greenStatus,
  } as BoxProps,
  in_process: {
    ...defaultStyles.blueStatus,
  } as BoxProps,
  'on hold': {
    ...defaultStyles.greyStatus,
  } as BoxProps,
  approved: {
    ...defaultStyles.greenStatus,
  } as BoxProps,
  'pending for approval': {
    ...defaultStyles.orangeStatus,
  } as BoxProps,
  rejected: {
    ...defaultStyles.redStatus,
  } as BoxProps,
  rework: {
    ...defaultStyles.orangeStatus,
  } as BoxProps,
  hold: {
    ...defaultStyles.redStatus,
  } as BoxProps,
  release: {
    ...defaultStyles.orangeStatus,
  } as BoxProps,
  titleView: {
    opacity: 0.88,
    paddingVertical: 16,
    paddingHorizontal: 16,
  } as BoxProps,
  title: {
    fontSize: 12,
    color: 'BLACK_21',
    flexShrink: 1,
    fontFamily: 'jiotype-medium',
  } as TextProps,
  titleheaderView: {
    flexDirection: 'row',
  } as BoxProps,
  titleHeader: {
    color: 'BLACK_21',
    fontSize: 12,
    textTransform: 'capitalize',
    fontFamily: 'jioType-bold',
  } as TextProps,

  linkStyle: {
    color: 'BLUE',
    fontSize: 12,
    // textAlign: 'center',
    fontFamily: 'jiotype-medium',
  } as TextProps,
  rootContainer: (height?: number) =>
    ({
      flexDirection: 'row',
      w: '100%',
      h: height ?? '100%',
      borderWidth: 1,
      borderColor: 'GRAY_BORDER',
      borderRadius: 4,
      flexGrow: 1,
      alignContent: 'center',
    } as BoxProps),
}
